import api from './api';
import { Agente } from '../types';

type AgentesApiResponse = Agente[] | { data?: Agente[]; total?: number };

export interface GetAgentesParams {
	page?: number;
	limit?: number;
	search?: string;
}

export const getAgentes = (params: GetAgentesParams = {}) =>
	api.get<AgentesApiResponse>('/agentes', { params }).then((res) => {
		const normalizedData = Array.isArray(res.data)
			? res.data
			: Array.isArray(res.data?.data)
				? res.data.data
				: [];

		if (!Array.isArray(res.data) && !Array.isArray(res.data?.data)) {
			console.warn('[agentes.service] Unexpected /agentes response shape', res.data);
		}

		const total = Array.isArray(res.data)
			? res.data.length
			: typeof res.data?.total === 'number'
				? res.data.total
				: normalizedData.length;

		return {
			...res,
			data: normalizedData,
			total,
		};
	});
export const getAgente = (id: string) => api.get<Agente>(`/agentes/${id}`);
export const createAgente = (data: Partial<Agente>) => api.post<Agente>('/agentes', data);
export const updateAgente = (id: string, data: Partial<Agente>) => api.patch<Agente>(`/agentes/${id}`, data);
export const deleteAgente = (id: string) => api.delete(`/agentes/${id}`);
